import { getFirestore, collection, getDocs, query } from 'firebase/firestore/lite';
import app from '../firebase';
import { firebaseCollection } from '../constants';

/*
 * !Important: This file has only get operations of firebase actions.
 * @function firebaseGet
 * @description get operations of firestore collection(s)
 * @param {object} data - the data to be stored in the document
 * @param {string} collection - the name of the collection
 * @return {object} - the firebase document
 */

export const db = getFirestore(app);

export async function getChatMessage(classId) {
  const messageRef = query(collection(db, `${firebaseCollection.CHAT_MESSAGE}${classId}`));
  const snapshot = await getDocs(messageRef);
  return snapshot;
}
